<template>
    <VJoyDialog data-testid="vetting-simple-dialog" aria-labelledby="vettingSimpleConfirmDialog" open @dialog:hide="emits('cancel')">
        <template #dialog-header>
            <p id="confirmDialogTitle">
                {{ $t(`profile.vetting.community.vetting.decision.dialog.title.${action.toUpperCase()}.${vertical}` as TranslationKey) }}
            </p>
        </template>

        <template #dialog-body>
            <div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <p v-html="$t(`profile.vetting.community.vetting.decision.dialog.subtitle.${action.toUpperCase()}.${vertical}` as TranslationKey)" />
            </div>
        </template>

        <template #dialog-cancel>
            <VJoyButton
                variant="ghost"
                :loading="!!freelancerVerticalStore.loading"
                :label="$t('profile.vetting.community.vetting.decision.dialog.cancel.cta')"
                @click="$emit('cancel')"
            />
        </template>
        <template #dialog-confirm>
            <VJoyButton
                data-testid="vetting-simple-dialog-confirm"
                variant="main"
                :loading="!!freelancerVerticalStore.loading"
                :label="$t('profile.vetting.community.vetting.decision.dialog.confirm.cta')"
                @click="handleConfirm"
            />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {pushVJoySnackbar, VJoyDialog, VJoyButton} from '@maltjoy/core-vue';
    import {FreelancerVertical} from '@api';
    import {useFreelancerVerticalStore} from '~/store/freelancerVerticalStore';
    import {DialogAction} from './Dialog.model';
    import type {TranslationKey} from '#build/i18n';

    const freelancerVerticalStore = useFreelancerVerticalStore();

    const props = defineProps<{
        action: DialogAction;
        vertical: FreelancerVertical;
    }>();

    const emits = defineEmits<{
        confirm: [];
        cancel: [];
    }>();

    async function handleConfirm() {
        try {
            if (props.action === DialogAction.Refuse && props.vertical === FreelancerVertical.Strategy) {
                await freelancerVerticalStore.refuseSilentlyToStrategy();
                emits('confirm');
            }
        } catch (error: any) {
            pushVJoySnackbar({
                props: {
                    message: error,
                    level: 'error',
                },
            });

            throw error;
        }
    }
</script>
